import * as e from "react";
const l = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M11.3 3.6h1.4l.2.1v16.6l-.2.1h-1.4l-.2-.1V3.6l.2-.1z" }), /* @__PURE__ */ e.createElement("path", { d: "M4.1 11.1H20c.1 0 .2 0 .2.2v1.4l-.2.2H4c-.1 0-.2 0-.2-.2v-1.4l.2-.2z" }));
export {
  l as ReactComponent
};
